// extracted by mini-css-extract-plugin
module.exports = {"cell":"RecommendedCellCdo_cell__g__xB","limit-recommendation-close":"RecommendedCellCdo_limit-recommendation-close__ZUyqq"};